export default __webpack_public_path__ + "file/Fiche-FR-Produit-Puroak-Block-24.asset.8c0d69da.pdf";